import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'pos-edit-option',
  templateUrl: './edit-option.modal.html',
  styleUrls: ['./edit-option.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditOptionModal implements OnInit {
  @Input('name') name: string;
  @Input('price') price: number;

  readonly form = this.fb.group({
    name: ['', Validators.required],
    price: [null, null]
  });

  constructor(
    private modalController: ModalController,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.form.setValue({
      name: this.name,
      price: this.price
    });
  }

  cancel() {
    this.modalController.dismiss();
  }

  submit() {
    const { name, price } = this.form.getRawValue();

    this.modalController.dismiss({
      name,
      price
    });
  }
}
